'use client'

import Link from 'next/link'

export const Header = () => {
  return (
    <header className="w-full bg-white h-12 header:h-[100px]">
      <div className="max-w-[1440px] mx-auto px-[3vw] h-full flex items-center justify-between header:justify-between">
        {/* ロゴ */}
        <Link href="/" className="flex items-center justify-center header:justify-start w-full header:w-auto">
          <img
            src="/images/lp-logo.png"
            alt="オリジナルeカタログギフト"
            className="h-8 header:h-12 w-auto object-contain"
          />
        </Link>

        {/* CTAボタン（PC only） */}
        <div className="hidden header:flex items-center gap-[10px]">
          <button
            type="button"
            className="flex items-center justify-center font-bold transition-all duration-200 text-white px-6 py-3"
            style={{
              backgroundColor: '#DA3B78',
              borderRadius: '8px',
              boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
              width: '341px',
              border: 'none',
              cursor: 'pointer',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#C23468'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#DA3B78'
            }}
            onClick={() => {
              const contactSection = document.getElementById('contact')
              if (contactSection) {
                window.history.pushState(null, '', '/?form=consultation')
                contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            }}
          >
            <div className="flex flex-col gap-0.5 items-center">
              <div className="flex gap-1 items-center justify-center">
                <div
                  className="text-white"
                  style={{ fontSize: '12px', lineHeight: '1.5', letterSpacing: '0.48px', fontWeight: 600 }}
                >
                  サービスのより詳しい説明はこちら
                </div>
              </div>
              <div
                className="text-white text-center"
                style={{ fontSize: '16px', lineHeight: '1.5', letterSpacing: '0.64px', fontWeight: 600 }}
              >
                お問い合わせ・資料請求
              </div>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0 ml-0.5"
              aria-hidden="true"
            >
              <path d="M9 5L16 12L9 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <a
            href="https://web.catalog.giftmall.co.jp/signup"
            className="flex items-center justify-center font-bold transition-all duration-200 px-6 py-3"
            style={{
              backgroundColor: 'white',
              color: '#DA3B78',
              borderRadius: '8px',
              boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
              width: '341px',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#FFF5F9'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'white'
            }}
          >
            <div className="flex flex-col gap-0.5 items-center justify-center">
              <div className="flex gap-1 items-center justify-center">
                <div
                  style={{
                    fontSize: '12px',
                    lineHeight: '1.5',
                    letterSpacing: '0.48px',
                    fontWeight: 600,
                    color: '#DA3B78',
                  }}
                >
                  WEB完結で即時発注も可能
                </div>
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: '16px',
                  lineHeight: '1.5',
                  letterSpacing: '0.64px',
                  fontWeight: 600,
                  color: '#DA3B78',
                }}
              >
                無料アカウント登録
              </div>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0 ml-0.5"
              aria-hidden="true"
            >
              <path d="M9 5L16 12L9 19" stroke="#DA3B78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </header>
  )
}
